import React from "react";
import {
  ToggleContainer,
  ToggleDescription,
  ToggleInfo,
  ToggleLabel,
  ToggleSlider,
  ToggleSwitch,
} from "./styles";
import { ToggleComponentProps } from "./types";

export const ToggleComponent: React.FC<ToggleComponentProps> = ({
  checked,
  onChange,
  label,
  description,
  testId,
  disabled = false,
}) => (
  <ToggleContainer>
    <ToggleInfo>
      <ToggleLabel>{label}</ToggleLabel>
      <ToggleDescription>{description}</ToggleDescription>
    </ToggleInfo>
    <ToggleSwitch
      type="button"
      role="switch"
      aria-label={label}
      aria-checked={checked}
      data-testid={testId}
      checked={checked}
      onClick={() => !disabled && onChange(!checked)}
      disabled={disabled}
      style={{
        opacity: disabled ? 0.5 : 1,
        cursor: disabled ? "revert" : "pointer",
      }}
    >
      <ToggleSlider checked={checked} />
    </ToggleSwitch>
  </ToggleContainer>
);

export const Toggle = React.memo(ToggleComponent);
